import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { sliderAnatomy } from "@chakra-ui/react/anatomy";

export default defineSlotRecipe({
  slots: sliderAnatomy.keys(),
  variants: {
    variant: {
      outline: {
        track: {
          bg: "bg.muted",
        },
      },
    },
  },
});
